<template>
    <div class="container d-flex justify-content-center align-items-center min-vh-100">
        <div class="card shadow p-4" style="width: 350px;">
            <div class="text-center mb-3">
                <img :src="logoUrl" alt="Company Logo" class="img-fluid" style="max-height: 60px;" />
            </div>
            <h3 class="text-center mb-3">Set Password</h3>
            <form @submit.prevent="setPassword">
                <div class="mb-3">
                    <input v-model="password" type="password" class="form-control my-2" placeholder="Password" required />
                </div>
                <div class="mb-3">
                    <input v-model="password2" type="password" class="form-control my-2" placeholder="Confirm Password" required />
                </div>
                <button class="btn btn-primary w-100 mb-2" type="submit" :disabled="loading">
                    <output v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                    Set Password
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import eventBus from "@/utils/eventBus";

export default {
    data() {
        return {
            logoUrl: process.env.VUE_APP_LOGO_URL,
            email: '',
            password: '',
            password2: '', // Add this line to define password2
            passwordUpdateToken: '',
            emailVerificationToken: '',
            loading: false
        };
    },
    created() {
        // Initialize data values from URL parameters
        this.email = this.$route.query.email || '';
        this.passwordUpdateToken = this.$route.query.puToken || '';
        this.emailVerificationToken = this.$route.query.evToken || null;
    },
    methods: {
        async setPassword() {
            this.loading = true;
            if (this.password !== this.password2) {
                eventBus.emit('show-alert', { message: 'Passwords do not match.', type: 'danger' });
                this.loading = false;
                return;
            }
            let payload = {
                email: this.email,
                password: this.password,
                passwordUpdateToken: this.passwordUpdateToken
            };
            if (this.emailVerificationToken) {
                payload.emailVerificationToken = this.emailVerificationToken;
            }
            try {
                const response = await api.put('/v1/auth/set-password', payload);

                if (response.status === 200) {
                    this.$router.push('/');
                    eventBus.emit('show-alert', {
                        message: 'Password set successfully. You can now log in.',
                        type: 'success'
                    });
                }
            } catch (error) {
                eventBus.emit('show-alert', { message: error.response.data.message, type: 'danger' });
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>